import React, { useState } from "react";
import { CheckCircle } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const SuccessMessage = ({ message }) => {
  const [show, setShow] = useState(true);
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-6 shadow-xl max-w-sm w-full text-center animate-fade-in relative">
        <span
          className="absolute top-0 right-0 cursor-pointer"
          onClick={() => {
            navigate("/dashboard/contest");
            setShow(false)
          }}
        >
          <CloseIcon />
        </span>
        <div className="flex flex-col items-center space-y-3">
          <CheckCircle className="text-green-600 w-10 h-10" />
          <p className="text-green-800 font-semibold text-lg">{message}</p>
          <a
            href="https://chat.whatsapp.com/KvWEue4ba535XvsOfp4O6J" 
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            Join WhatsApp Group
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessage;
